import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Form, Row, Col, Button, Collapse } from 'react-bootstrap';
import { FaSearch, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import DateFilterInput from '../Utils/DateFilterInput';
import IntegerInput from '../Utils/IntegerInput';
import PersonInput from '../Utils/PersonInput';
import ProductInput from '../Utils/ProductInput';
import { getCurrentDate, convertDateToISO, getCurrentDateMinusDays } from '../Utils/utils';

const TransfersFilter = ({ onFilter, onClear }) => {
  const [open, setOpen] = useState(true);
  
  const { register, handleSubmit, formState: { errors }, control, watch, setValue, reset } = useForm({
    defaultValues: {
      initialDate: getCurrentDateMinusDays(5),
      finalDate: getCurrentDate(),
      productId: null,
      originPerson: null,
      destinyPerson: null,
      oldId: '',
      active: false
    }
  });

  const onSubmit = async (data) => {
    const formattedPayload = {
      initialDate: convertDateToISO(data.initialDate) || undefined,
      finalDate: convertDateToISO(data.finalDate) || undefined,
      productId: data.productId?.id || undefined,
      originPerson: data.originPerson?.id || undefined,
      destinyPerson: data.destinyPerson?.id || undefined,
      oldId: data.oldId || undefined,
      active: !data.active
    };
    onFilter(formattedPayload);
  };

  const handleClear = () => {
    reset();
    onClear();
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <div
      style={{
        border: open ? '1px solid black' : 'none',
        borderRadius: '5px',
        padding: open ? '10px' : '0px',
        marginBottom: '20px',
        transition: 'all 0.3s ease-in-out',
      }}
    >
      <h6
        className="text-center mb-3 d-flex align-items-center justify-content-center"
        style={{ cursor: 'pointer' }}
        onClick={handleToggle}
      >
        Filtros Avançados{' '}
        {open ? <FaChevronUp className="ms-2" /> : <FaChevronDown className="ms-2" />}
      </h6>
      <Collapse in={open}>
        <div>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="mb-3">
              <Col md={2}>
                <IntegerInput
                  label="Código"
                  name="oldId"
                  register={register}
                  errors={errors}
                  placeholder="Código"
                  value={watch('oldId') || ''}
                  userRoles={false}
                />
              </Col>
              <Col md={2}>
                <Controller
                  name="initialDate"
                  control={control}
                  render={({ field }) => (
                    <DateFilterInput
                      label="Data Inicial"
                      value={field.value}
                      onChange={field.onChange}
                    />
                  )}
                />
              </Col>
              <Col md={2}>
                <Controller
                  name="finalDate"
                  control={control}
                  render={({ field }) => (
                    <DateFilterInput
                      label="Data Final"
                      value={field.value}
                      onChange={field.onChange}
                    />
                  )}
                />
              </Col>
              <Col md={6}>
                <Controller
                  name="productId"
                  control={control}
                  render={({ field, fieldState }) => (
                    <ProductInput
                      value={field.value}
                      createdNew={false}
                      onChange={(selected) => setValue('productId', selected)}
                      onCreated={(created) => {
                        setValue('productId', { id: created.id, description: created.description });
                      }}
                      label="Produto (cultura)"
                      isInvalid={!!fieldState.error}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={5}>
                <Controller
                  name="originPerson"
                  control={control}
                  render={({ field, fieldState }) => (
                    <PersonInput
                      value={field.value}
                      createdNew={false}
                      onChange={(selected) => setValue('originPerson', selected)}
                      onCreated={(created) => {
                        setValue('originPerson', { id: created.id, name: created.name });
                      }}
                      label="Origem"
                      isInvalid={!!fieldState.error}
                      type={['isCustomer', 'isProducer', 'isSupplier' , 'isDriver']}
                      autoComplete='off'
                    />
                  )}
                />
              </Col>
              <Col md={5}>
                <Controller
                  name="destinyPerson"
                  control={control}
                  render={({ field, fieldState }) => (
                    <PersonInput
                      value={field.value}
                      createdNew={false}
                      onChange={(selected) => setValue('destinyPerson', selected)}
                      onCreated={(created) => {
                        setValue('destinyPerson', { id: created.id, name: created.name });
                      }}
                      label="Destino"
                      isInvalid={!!fieldState.error}
                      type={['isCustomer', 'isProducer', 'isSupplier' , 'isDriver']}
                      autoComplete='off'
                    />
                  )}
                />
              </Col>
              <Col md={2}>
                <Controller
                  name="active"
                  control={control}
                  render={({ field }) => (
                    <Form.Group
                      controlId="status"
                      style={{ border: 'solid #dee2e6 1px', padding: '5px 15px' }}
                      className="mb-3"
                    >
                      <Form.Label className="center">Status</Form.Label>
                      <Form.Check
                        type="checkbox"
                        label="Estornado"
                        checked={field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                    </Form.Group>
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="d-flex justify-content-start">
                <Button
                  variant="primary"
                  type="submit"
                  className="button-custom d-flex align-items-center me-2"
                >
                  <FaSearch className="me-2" /> Pesquisar
                </Button>
                <Button
                  variant="secondary"
                  onClick={handleClear}
                  className="d-flex align-items-center"
                >
                  Limpar
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Collapse>
    </div>
  );
};

export default TransfersFilter;